import { LogicContext } from '@/logic/main/types';

export const getCategoryDetailsLayoutContent = async (
  context: LogicContext
) => {
  const { currentJackpotsV2, controllersData } = context;

  if (!controllersData.categoryDetails) {
    return {
      updates: [],
    };
  }

  const updates = controllersData.categoryDetails?.components?.map(
    ([id, entry]) => ({
      type: 'setLayoutProperty',
      data: {
        path: `components.${id}.properties`,
        value: { ...entry.properties, currentJackpotsV2 },
      },
    })
  );

  return {
    updates,
  };
};
